import React from 'react';
import ReactDOM from 'react-dom';
import Home from './component/home';
import { BrowserRouter } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';


const history = createBrowserHistory();
console.log('process.env',process.env);
console.log('process.env.NODE_ENV',process.env.NODE_ENV);
//Starting file of the project, it will act as root node in DOM
ReactDOM.render((
  <BrowserRouter history={history}>
    <Home />
  </BrowserRouter>
), document.getElementById('root')
); 
